<template>
    <div class="ranking-list-item" :class="{ me: isMe }">
        <div class="ranking-num" v-if="isMe">
            <p class="my">{{ status === '4' ? '我' : '我的门店' }}</p>
            <p class="color-red">{{ item[getTheme('Rnk')] }}</p>
        </div>
        <div class="ranking-num" v-else>
            <p v-if="item[getTheme('Rnk')] > 3">{{ item[getTheme('Rnk')] }}</p>
            <img v-else :src="`https://staticwecom.beautyfarm.com.cn/wecom-workbench/2025-02-18/top${item[getTheme('Rnk')]}.png`" alt="">
        </div>
        <div class="ranking-name">
            <van-image class="img" round :src="item.avatar" error-icon="" v-if="status === '4'" />
            <div class="ellipsis" v-if="status !== '4'">{{ item.storeName }}</div>
            <div v-else class="ellipsis">
                <div>{{ item.employeeName }}</div>
                <div class="ellipsis store-name" v-if="status === '4'">{{ item.storeName }}</div>
            </div>
        </div>
        <div class="ranking-order" :class="{ counting: status === '3' }">
            {{ item[getTheme('order')] }}
            <span v-if="status !== '3'">w</span>
        </div>
        <div class="ranking-order" v-if="status === '1'">{{ item.accountAmtYoy || 0 }}%</div>
        <div class="ranking-bonus" v-else-if="status === '2'">{{ item.netAmtBfYoy || 0 }}%</div>
        <!-- <div class="ranking-bonus">{{ item.awardAmt }}元</div> -->
    </div>
</template>

<script>
    export default {
        name: 'RankingItem',
        props: {
            item: {
                type: Object,
                default: () => { }
            },
            isMe: {
                type: Boolean,
                default: false
            },
            index: {
                type: String,
                default: '0'
            },
            status: {
                type: String,
                default: '1'
            },
            statusTab: {
                type: String,
                default: '1'
            }
        },
        data() {
            return {

            }
        },
        methods: {
            // 获取主题色和图片和文字
            getTheme(type) {
                const index = this.status * 1 - 1
                const theme = {
                    cardBgColor: ['#FDE3D7', '#FDE3D7', '#F1DEA9', '#F6F2FF', '#F6F2FF'],
                    order: ['accountAmtMtd', 'netAmtBfMtd', 'userCntNewaddMemDisMtd', 'saleAmtBf'], // 金额对应字段
                    orderAmt: ['awardAmt', 'awardAmt', 'award', 'awardAmt', 'awardAmt'], // 金额对应字段
                    Rnk: ['accountAmtRnk1', 'netAmtBfRnk1', 'rnk1', 'rnk1'], // 排名
                }
                if (this.statusTab == '第5组') {
                    theme.order[1] = 'custflowTargetPer'
                }
                return theme[type][index];
            }
        }
    }
</script>

<style lang='less' scoped>
    .ranking-list-item {
        display: flex;
        align-items: center;
        justify-content: space-between;
        // margin: 10px 0;
        padding: 30px 40px;
        border-bottom: 2px solid #eeeeee;

        &.me {
            padding: 20px;
            margin-top: 30px;
            background-color: #FDE3D7;
            border-radius: 12px;
            border: none;
        }

        &.title {
            padding-bottom: 0;
            border: none;
            color: #999999;
        }

        // &:nth-last-child(1) {
        //     border: none;
        // }

        .ranking-num {
            width: 60px;
            margin-right: 30px;

            .color-red {
                color: #AB080B;
            }

            .my {
                font-size: 22px;
            }

            p {
                margin: 0;
                text-align: center;
            }

            >img {
                width: 50px;
                height: 60px;
            }
        }

        .ranking-name {
            display: flex;
            align-items: center;
            width: 240px;

            div {
                width: 100%;
            }

            >.img {
                width: 60px;
                height: 60px;
                min-width: 60px;
                margin-right: 10px;
            }

            .store-name {
                font-size: 22px;
            }

        }

        .ranking-order {
            width: 160px;
            text-align: center;
        }

        .counting {
            width: 230px;
        }

        .ranking-bonus {
            width: 180px;
            text-align: center;
        }
    }
</style>